import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  CardVerification,
  CardVerificationRequest,
  CardVerificationResponse,
} from './types'
import { format, subMonths } from 'date-fns'
import dayjs from 'dayjs'

export const cardVerificationMounted = createEvent<CardVerificationRequest>()

export const getCardVerification = fx<
  CardVerificationRequest,
  CardVerificationResponse
>({
  method: 'GET',
  url: `/user/fin_kpi/card_verification`,
})

export const $cardVerificationList = restore<CardVerification[]>(
  getCardVerification.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfCardVerification = restore(
  getCardVerification.doneData.map((a) => a.body.total),
  0,
)

export const $totalKPI = restore(
  getCardVerification.doneData.map((a) => a.body.totalKPI),
  null,
)

sample({
  // @ts-ignore
  clock: cardVerificationMounted,
  fn: ({ limit, page, userIds, beginPeriodAt, endPeriodAt }) => {
    let query = {
      limit,
      page,
      where: JSON.stringify({
        beginPeriodAt: beginPeriodAt
          ? beginPeriodAt
          : dayjs().startOf('month').format('YYYY-MM-DD'),
        endPeriodAt: endPeriodAt ? endPeriodAt : dayjs().format('YYYY-MM-DD'),
        user_ids: userIds,
      }),
    }

    return {
      query,
    }
  },
  target: getCardVerification,
})
